import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "react-paginate";
import { set_banner_details } from "../../../redux/actions/BannerAction";
import { FaChevronLeft, FaChevronRight, FaEdit, FaTrash } from "react-icons/fa";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import { apiJson } from "../../../api/Api";

const TableList = (props) => {
  const [activePage, setActivePage] = useState(0);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(10);
  const [redirect, setRedirect] = useState(false);
  const [bannerID, setBannerID] = useState("");
  const handlePageChange = (pageNumber) => {
    setMin(pageNumber.selected * 10);
    setMax((pageNumber.selected + 1) * 10);
    setActivePage(pageNumber.selected);
  };
  const getBannerDetails = (id) => {
    return props.List.filter((item) => {
      return item.id === id;
    })[0];
  };

  useEffect(() => {
    setMin(0);
    setMax(10);
    setActivePage(0);
  }, [props.List]);



  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showBanner = (id) => {
    setBannerID(id);
    const bannerDetails = getBannerDetails(id);
    props.set_banner_details({ bannerDetails: bannerDetails });
    setRedirect(true);
  };

  return (
    <div className="table-responsive">
      <Table hover className="overflow-auto borderless">
        <thead style={{ borderBottom: "#F5F5F9" }}>
          <tr className="table-head">
            <td className="header-text">Banner Id</td>
            <td className="header-text">Type</td>
            <td className="header-text">Position</td>
            <td className="w-25 header-text">Image</td>
            {/* <td>Action</td> */}
          </tr>
        </thead>
        <tbody>
          {props.List &&
            props.List.slice(min, max).map((banner) => {
              return (
                <tr
                  key={banner.id}
                  onClick={() => showBanner(banner.id)}
                  style={{ cursor: "pointer" }}
                >
                  <td className="header-text">{banner.id}</td>
                  <td
                    className="header-text"
                    style={{ textTransform: "capitalize" }}
                  >
                    {banner.banner_type.split("_")[0]}{" "}
                    {banner.banner_type.split("_")[1]}
                  </td>
                  <td className="header-text w-25">
                    <a href={banner.redirect_to}>{banner.position}</a>
                  </td>
                  <td className="w-25 header-text">
                    <a href={banner.image}>
                      <div
                        className="image-container mx-auto"
                        style={{ height: "100px" }}
                      >
                        <img
                          src={banner.image}
                          alt="banner"
                          height="100%"
                        />
                      </div>
                    </a>
                  </td>
                  {/* <td>
                    <Link to={"/vendor/shop-banner/update/" + banner.id}>
                      <FaEdit />
                    </Link>
                    &nbsp;&nbsp;&nbsp;
                    <span className="text-danger" onClick={() => deleteBanner(banner.id)}>
                      <FaTrash />
                    </span>
                  </td> */}
                </tr>
              );
            })}
        </tbody>
      </Table>
      {redirect && (
        <Redirect
          push
          to={{
            pathname: `/vendor/view-shop-banner/${bannerID}`,
            state: { name: "view" },
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bannerDetails: state.banner.bannerDetails,
  };
};

const mapDispatchTopProps = { set_banner_details };

export default connect(mapStateToProps, mapDispatchTopProps)(TableList);
